import React, { useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { message } from 'antd';

import { Header, Title } from '$app/shared/components/Header';
import { Container } from '$app/shared/components/Container';

import { normalizePhoneFields, HERO_MOBILE_FIELD_NAMES } from '$app/shared/utils/phoneValidation';
import makeHeroesForm from '../HeroesForm';
import Loading from '$app/shared/components/Loading';
import { createHero, fetchDriverZones, getHeroesErrorMessage } from '../../heroesApi';

const HeroesForm = makeHeroesForm();

function HeroesCreatePage({ history }) {
  const [zones, setZones] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadZones = async () => {
      try {
        const nextZones = await fetchDriverZones();
        if (isMounted) {
          setZones(nextZones);
        }
      } catch (error) {
        message.error(getHeroesErrorMessage(error));
        if (isMounted) {
          setZones([]);
        }
      }
    };

    loadZones();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleSubmit = (event, form) => {
    form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        try {
          setLoading(true);
          const hero = await createHero(
            normalizePhoneFields(values, values.segment, HERO_MOBILE_FIELD_NAMES, {
              mobileOnlyFields: HERO_MOBILE_FIELD_NAMES,
            })
          );
          message.success('Saved hero');
          history.push(`/heroes/${hero.driverId}/edit`);
        } catch (error) {
          message.error(getHeroesErrorMessage(error));
        } finally {
          setLoading(false);
        }
      }
    });
  };

  if (!zones) {
    return <Loading />;
  }

  return (
    <Container style={{ height: window.innerHeight }}>
      <Header>
        <Link to="/heroes">Back</Link>
        <Title>Create Hero</Title>
      </Header>
      <HeroesForm onSubmit={handleSubmit} zones={zones} loading={loading} />
    </Container>
  );
}

export default withRouter(HeroesCreatePage);
